import { render, staticRenderFns } from "./VesselHistory.vue?vue&type=template&id=45d25e76&scoped=true&"
import script from "./VesselHistory.vue?vue&type=script&lang=js&"
export * from "./VesselHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d25e76",
  null
  
)

export default component.exports